
(function () {
  if (window.__veeryWishlistDrawerReady) return;
  window.__veeryWishlistDrawerReady = true;

  var overlay = document.querySelector('[data-vwl-overlay]');
  var drawer = document.querySelector('[data-vwl-drawer]');
  var body = drawer ? drawer.querySelector('[data-vwl-body]') : null;
  var countText = drawer ? drawer.querySelector('[data-vwl-count-text]') : null;
  var countLabel = drawer ? drawer.querySelector('[data-vwl-count-label]') : null;
  if (!drawer || !body) return;

  var LBL_REMOVE = drawer.getAttribute('data-vwl-lbl-remove') || 'Remove';
  function lbl(nombre, reserva) { return drawer.getAttribute('data-vwl-' + nombre) || reserva; }

  var abierto = false;
  var focoPrevio = null;
  var inertes = [];

  function enfocables() {
    var sel = 'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var todos = drawer.querySelectorAll(sel);
    var visibles = [];
    for (var i = 0; i < todos.length; i++) {
      if (todos[i].closest('[aria-hidden="true"]') && todos[i].closest('[aria-hidden="true"]') !== drawer) continue;
      if (todos[i].offsetParent !== null || todos[i] === document.activeElement) visibles.push(todos[i]);
    }
    return visibles;
  }

  function atraparTab(e) {
    if (!abierto || e.key !== 'Tab') return;
    var f = enfocables();
    if (!f.length) { e.preventDefault(); return; }
    var idx = f.indexOf(document.activeElement);
    var dentro = drawer.contains(document.activeElement);
    if (e.shiftKey && idx <= 0) {
      e.preventDefault();
      f[f.length - 1].focus();
    } else if (!e.shiftKey && (!dentro || idx === f.length - 1)) {
      e.preventDefault();
      f[0].focus();
    }
  }

  function ponerInert() {
    if (inertes.length) return;
    inertes = [];
    var hijos = document.body.children;
    for (var i = 0; i < hijos.length; i++) {
      var el = hijos[i];
      if (el.contains(drawer) || el.tagName === 'SCRIPT' || el.hasAttribute('inert')) continue;
      el.setAttribute('inert', '');
      inertes.push(el);
    }
  }
  function quitarInert() {
    for (var i = 0; i < inertes.length; i++) inertes[i].removeAttribute('inert');
    inertes = [];
  }

  function enfocarTitulo() {
    var titulo = drawer.querySelector('.vwl__title');
    if (!titulo) return;
    if (!titulo.hasAttribute('tabindex')) titulo.setAttribute('tabindex', '-1');
    titulo.focus({ preventScroll: true });
  }

  function openDrawer() {
    render();
    if (!abierto) focoPrevio = document.activeElement;
    abierto = true;
    drawer.setAttribute('data-open', 'true');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    ponerInert();
    enfocarTitulo();
    var intentos = 0;
    (function reintentar() {
      if (!abierto || drawer.contains(document.activeElement) || intentos++ > 5) return;
      setTimeout(function () { enfocarTitulo(); reintentar(); }, 100);
    })();
  }
  function closeDrawer() {
    limpiarDeshacer();
    var estabaAbierto = abierto;
    abierto = false;
    drawer.setAttribute('data-open', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.setAttribute('data-open', 'false');
    document.body.style.overflow = '';
    quitarInert();
    if (!estabaAbierto) return;
    var destino = focoPrevio && document.contains(focoPrevio) ? focoPrevio : null;
    if (!destino) {
      var corazones = document.querySelectorAll('[data-vwl-open]');
      for (var i = 0; i < corazones.length; i++) {
        if (corazones[i].offsetParent !== null) { destino = corazones[i]; break; }
      }
    }
    focoPrevio = null;
    if (destino && typeof destino.focus === 'function') destino.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest ? e.target.closest('[data-vwl-open]') : null;
    if (opener) { e.preventDefault(); openDrawer(); return; }
    var closer = e.target.closest ? e.target.closest('[data-vwl-close]') : null;
    if (closer) { closeDrawer(); }
  });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && abierto) closeDrawer();
    atraparTab(e);
  });

  function formatMoney(cents) {
    return window.VeeryWishlist.formatMoney(cents);
  }
  function esc(str) {
    return window.VeeryWishlist.escapeHtml(str);
  }


  function cdn(url, w) {
    if (!url) return '';
    var u = url.indexOf('//') === 0 ? 'https:' + url : url;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function priceHtml(p) {
    var cifra = function (c) { return '<span class="veery-cartela__cifra">' + formatMoney(c) + '</span>'; };
    if (p.price_varies) {
      var desde = lbl('lbl-desde', 'From __PRECIO__').split('__PRECIO__');
      return '<span>' + (desde[0] ? '<span class="veery-cartela__desde">' + esc(desde[0]) + '</span>' : '') + cifra(p.price_min) + (desde[1] ? '<span class="veery-cartela__desde">' + esc(desde[1]) + '</span>' : '') + '</span>';
    }
    if (p.compare_at_price && p.compare_at_price > p.price) {
      return '<ins>' + cifra(p.price) + '</ins>' +
             '<del class="veery-cartela__tachado">' + formatMoney(p.compare_at_price) + '</del>';
    }
    return '<span>' + cifra(p.price) + '</span>';
  }

  function resumenOpciones(p) {
    var partes = [];
    (p.options || []).forEach(function (o) {
      var n = o.values ? o.values.length : 0;
      if (n < 2 || !o.name) return;
      var nombre = String(o.name).toLowerCase();
      var plural = /(s|sh|ch|x)$/.test(nombre) ? nombre + 'es' : nombre + 's';
      partes.push(n + ' ' + plural);
    });
    return partes.join(' · ');
  }

  function accionPrincipal(p, url) {
    if (p.available === false) {
      return '<span class="vwl__agotado">' + esc(lbl('lbl-agotado', 'Sold out')) + '</span>';
    }
    var opciones = (p.options || []).filter(function (o) { return o.values && o.values.length > 1; });
    var tieneTalla = opciones.some(function (o) { return /^size$/i.test(o.name) || /^\s*\d+(?:[.,]\d+)?\s*[x×]\s*\d+/i.test(o.values[0]); });
    var tx = (drawer && drawer.dataset) || {};
    var texto = tieneTalla ? (tx.vwlLblElegirTalla || 'Choose size') : (opciones.length ? (tx.vwlLblElegirOpciones || 'Choose options') : (tx.vwlLblVer || 'View print'));
    return '<a class="vwl__elegir" href="' + url + '">' + texto + '</a>';
  }

  function emptyMarkup() {
    return (
      '<div class="vwl__empty">' +
        '<span class="vwl__empty-icon">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true">' +
            '<path d="M12 20s-7-4.35-7-9.5A3.5 3.5 0 0 1 12 7a3.5 3.5 0 0 1 7 3.5C19 15.65 12 20 12 20z"/>' +
          '</svg>' +
        '</span>' +
        '<p class="vwl__empty-title">' + esc(lbl('lbl-vacio-titulo', 'No favorites yet')) + '</p>' +
        '<p class="vwl__empty-text">' + esc(lbl('lbl-vacio-texto', 'Tap the heart on any print to keep it here while you decide. No account needed.')) + '</p>' +
        '<a class="vwl__empty-cta" href="' + esc(lbl('url-vacio', '/collections/all')) + '">' + esc(lbl('lbl-vacio-enlace', 'Explore prints')) + '</a>' +
      '</div>'
    );
  }

  var deshacer = null;
  function limpiarDeshacer() {
    if (deshacer && deshacer.timer) clearTimeout(deshacer.timer);
    deshacer = null;
  }
  function undoMarkup() {
    var quitada = lbl('lbl-quitada', '__obra__ removed').split('__obra__');
    return (
      '<div class="vwl__undo" role="status">' +
        '<span class="vwl__undo-text">' + esc(quitada[0] || '') + '<span class="vwl__undo-obra">' + esc(deshacer.titulo) + '</span>' + esc(quitada[1] || '') + '</span>' +
        '<button type="button" class="vwl__undo-btn" data-vwl-undo>' + esc(lbl('lbl-deshacer', 'Undo')) + '</button>' +
      '</div>'
    );
  }

  function cardHtml(handle, p) {
    var raizIdioma = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var url = raizIdioma + 'products/' + handle;
    var img = (p.images && p.images[0]) || p.featured_image || '';
    var detalle = resumenOpciones(p);
    return (
      '<a class="vwl__thumb" href="' + url + '" tabindex="-1" aria-hidden="true">' +
        (img ? '<img src="' + cdn(img, 200) + '" srcset="' + cdn(img, 200) + ' 200w, ' + cdn(img, 400) + ' 400w" sizes="88px" alt="" loading="lazy">' : '') +
      '</a>' +
      '<div class="vwl__info">' +
        '<div class="veery-cartela"><div class="veery-cartela__fila">' +
          '<h3 class="veery-cartela__nombre"><a class="veery-cartela__enlace" href="' + url + '">' + esc(p.title) + '</a></h3>' +
          '<p class="veery-cartela__precio">' + priceHtml(p) + '</p>' +
        '</div></div>' +
        (detalle ? '<p class="vwl__detalle">' + esc(detalle) + '</p>' : '') +
        '<div class="vwl__acciones">' +
          accionPrincipal(p, url) +
          '<button type="button" class="vwl__quitar" data-vwl-remove="' + esc(handle) + '" aria-label="' + esc(LBL_REMOVE + ' ' + p.title) + '">' + esc(LBL_REMOVE) + '</button>' +
        '</div>' +
      '</div>'
    );
  }

  function render() {
    var W = window.VeeryWishlist;
    if (!W) return;
    var handles = W.getAll();

    if (countText) countText.textContent = handles.length;
    var lbl = (drawer && drawer.dataset) || {};
    if (countLabel) countLabel.textContent = handles.length === 1 ? (lbl.vwlLblLamina || 'print') : (lbl.vwlLblLaminas || 'prints');

    var franja = deshacer ? undoMarkup() : '';

    if (handles.length === 0) {
      drawer.setAttribute('data-empty', 'true');
      body.innerHTML = franja + emptyMarkup();
      return;
    }
    drawer.setAttribute('data-empty', 'false');

    body.innerHTML = franja;
    for (var i = 0; i < handles.length; i++) {
      (function (handle) {
        var row = document.createElement('div');
        row.className = 'vwl__item is-loading';
        row.setAttribute('data-vwl-row', handle);
        row.innerHTML = '<div class="vwl__thumb"></div><div class="vwl__info"></div>';
        body.appendChild(row);

        W.fetchProduct(handle).then(function (product) {
          row.classList.remove('is-loading');
          row.setAttribute('data-vwl-title', product.title || '');
          row.innerHTML = cardHtml(handle, product);
        }).catch(function () {
          W.remove(handle);
          if (row.parentNode) row.parentNode.removeChild(row);
        });
      })(handles[i]);
    }
  }

  body.addEventListener('click', function (e) {
    var W = window.VeeryWishlist;
    if (!W || !e.target.closest) return;

    var undo = e.target.closest('[data-vwl-undo]');
    if (undo) {
      var volver = deshacer && deshacer.handle;
      var sitio = deshacer ? deshacer.indice : -1;
      limpiarDeshacer();
      if (!volver) return;
      if (typeof W.insertAt === 'function') W.insertAt(volver, sitio);
      else W.add(volver);
      return;
    }

    var btn = e.target.closest('[data-vwl-remove]');
    if (!btn) return;
    var handle = btn.getAttribute('data-vwl-remove');
    var fila = btn.closest('[data-vwl-row]');
    limpiarDeshacer();
    deshacer = {
      handle: handle,
      indice: W.getAll().indexOf(handle),
      titulo: (fila && fila.getAttribute('data-vwl-title')) || 'Print',
      timer: setTimeout(function () {
        deshacer = null;
        var f = body.querySelector('.vwl__undo');
        if (f && f.parentNode) f.parentNode.removeChild(f);
      }, 6000)
    };
    W.remove(handle);
  });

  document.addEventListener('veery:wishlist:change', function () {
    if (drawer.getAttribute('data-open') === 'true') render();
  });
})();
